import React from 'react';
import './CoursePackageTile.css';

function CoursePackageTile({ course, onSelect, isSelected, isRecommendedByQuiz }) {
    const tileClasses = `course-tile ${isSelected ? 'selected' : ''} ${isRecommendedByQuiz ? 'course-tile--recommended-quiz' : ''}`;
    return (
        <div
            id={`course-tile-${course.id}`}
            className={tileClasses}
            onClick={() => onSelect(course)}
        >
            <div className="course-tile-icon">{course.icon}</div>
            <h3 className="course-tile-name">{course.name}</h3>
            <p className="course-tile-description">{course.tileDescription}</p>
            {isRecommendedByQuiz && <div className="recommended-badge">Recommended for You!</div>}
            <button className="course-tile-button">
                {isSelected ? 'View Details Below' : 'Learn More'}
            </button>
        </div>
    );
}

export default CoursePackageTile;